import { useState, useEffect } from "react";
import { recurringApi } from "../api/recurring";

export const useOperationHistory = ({ projectId, activityId }: { projectId: string | undefined, activityId: string }) => {

    const [filter, setFilter] = useState('All');
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    
    const [data, setData] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [error, setError] = useState<any>(null);

    const handlePageChange = (value: number) => {
        setPage(value);
    };

    const handleRowsPerPageChange = (value: number) => {
        setRowsPerPage(value);
        setPage(1);
    };

    const fetchData = async () => {
        try {
            setIsLoading(true);
            setIsError(false);
            setError(null);
            const response = await recurringApi.getRecurringTaskEvents({ 
                projectId, 
                activityId, 
                page, 
                limit: rowsPerPage, 
                filter 
            });
            setData(response);
        } catch (err) {
            setIsError(true);
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (projectId && activityId) {
            fetchData();
        }
    }, [projectId, activityId, filter, page, rowsPerPage]);

    const refetch = () => {
        fetchData();
    };

    return {
        filter,
        setFilter,
        isError,
        error,
        pagiantion: data?.data?.pagination ?? null,
        eventHistory: data?.data?.event_history ?? [],
        isLoading,
        handlePageChange,
        handleRowsPerPageChange,
        refetch,
    };

};